import { playerBlendKey } from "@/lib/adminRankings";

const FC_QUERY = new URLSearchParams({
  isDynasty: "true",
  numQbs: "2",
  numTeams: "12",
  ppr: "1",
  includePicks: "true",
});

/**
 * Live FantasyCalc values (same query as admin rankings editor).
 * Used so blended TRYSTOMATIC values match everywhere.
 */
export async function fetchFantasyCalcValues() {
  const response = await fetch(`https://api.fantasycalc.com/values/current?${FC_QUERY.toString()}`);
  if (!response.ok) throw new Error("FantasyCalc request failed");
  const data = await response.json();
  const byKey = new Map();
  const byName = new Map();
  for (const entry of data) {
    const key = playerBlendKey(entry?.player || {});
    const value = Number(entry.value || 0);
    if (key) byKey.set(key, value);
    if (entry?.player?.name) byName.set(entry.player.name, value);
  }
  return { byKey, byName, count: data.length };
}

/**
 * Overlay FantasyCalc API numbers on backend players (fallback to player fields if maps miss).
 */
export function mergePlayersWithFantasyCalc(players, fantasyCalc) {
  const byKey = fantasyCalc?.byKey instanceof Map ? fantasyCalc.byKey : new Map();
  const byName = fantasyCalc?.byName instanceof Map ? fantasyCalc.byName : new Map();
  return (players || []).map((player) => {
    const fallback = Number(player.fcValue ?? player.value ?? player.combinedValue ?? 0) || 0;
    const fcValue = byKey.get(playerBlendKey(player)) ?? byName.get(player.name) ?? fallback;
    return { ...player, fcValue, value: fcValue, combinedValue: fcValue };
  });
}
